import React from "react";
import bugsnag from "@bugsnag/js";
import bugsnagReact from "@bugsnag/plugin-react";

setTimeout(() => {}).__proto__.unref = () => {};

const bugsnagClient = bugsnag(process.env.REACT_APP_BUGSNAG || "xxxxx");
bugsnagClient.use(bugsnagReact, React);

// wrap your entire app tree in the ErrorBoundary provided
const ErrorBoundary = bugsnagClient.getPlugin("react");

export { ErrorBoundary as ErrorBoundary, bugsnagClient as Bugsnag };
